<template>
  <v-card
      class="mx-auto"
      :class="backGroundColor"
      flat
  >
    <v-card-title class="text-overline pb-12 font-weight-bold">
      {{ showTitle }}
    </v-card-title>
    <v-card-subtitle class="text-h5 pb-3 text-center">
      {{ showSubTitle }}
    </v-card-subtitle>
    <v-card-text class="pb-15 text-fit-content" :style="textStyle">
      {{ showText }}
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: "result-message-card",
  props:{
    backGroundColor: {type: String, default: "accent2"},
    title: {type: String, default: null},
    subtitle: {type: String, default: null},
    text: {type: String, default: null},
    doWordBreak: {type: Boolean, default: true, required: false},
  },
  data() {
    return {
      textStyle: {
        wordBreak: this.doWordBreak ? '' : 'keep-all',
      },
    }
  },
  computed: {
    ...mapGetters({
      getBuyStateFormLabels: 'buyState/getFormLabels',
    }),
    buyStateFormLabels() {
      return this.getBuyStateFormLabels;
    },
    // propsを表示する場合と、Vuexの値を表示する場合がある
    // v-tabの不具合により、routingでparamsを渡せないため
    routePassCategoryName(){
      const passName = this.$route.name
      let passCategoryName;
      switch (true){
        case /Bank/.test( passName ):
          passCategoryName = "Bank"
          break;
        case /Upload/.test( passName ):
          passCategoryName = "Upload"
          break;
        default:
          passCategoryName = ""
      }
      return passCategoryName
    },
    showTitle(){
      if (this.$props.title) return this.$props.title
      return this.findCategoryMessage("Title")
    },
    showSubTitle(){
      if (this.$props.title) return this.$props.subtitle
      return this.findCategoryMessage("SubTitle")
    },
    showText(){
      if (this.$props.title) return this.$props.text
      return this.findCategoryMessage("Text")
    },
  },
  methods: {
    isCompleteRoute() {
      const passName = this.$route.name
      return passName.match(/complate/)
    },
    findCategoryMessage(topic){
      if (!this.routePassCategoryName) return ""
      const select = "message" + this.routePassCategoryName + topic
      return this.buyStateFormLabels[select]
    }
  },
}
</script>

<style scoped>
.text-fit-content{
  width: fit-content;
  margin: auto;
}
</style>